import contextLoadable from '@purecarslabs/signal-core/contextFetch/Loadable'
import { LeadFormSpecContext } from '@app-src/data/lead-form-spec/fetchContexts'
import { AccountMakeBrandContext } from '@app-src/data/make-brand/fetchContexts'
import Component from './Component'
import Loader from './Loader'
import Skeleton from './Skeleton'
import { FormContentPropsType } from './types'

// this is a context loadable, which renders the Component once all the fetch contexts are loaded, and renders the
// skeleton until they are loaded.
export default contextLoadable<FormContentPropsType>({
  fetchContexts: [AccountMakeBrandContext, LeadFormSpecContext],
  Component,
  Loader,
  Skeleton,
  useRefInTest: true
})
